import { h } from 'preact';
import { Accordion } from '../Accordion';
import { T } from '../../../styles/tokens';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'Accordion',
  category: '🗂️ Navegação',
  description: 'Accordion expansível com defaultOpen e badge numérico',
  usedIn: ['Profile', 'Integrations'],
  example: () => (
    <div style={{ border: '1px solid rgba(255,255,255,0.06)', borderRadius: 8 }}>
      <Accordion title="Aberto por padrão" defaultOpen={true}>
        <div style={{ color: T.textSecondary, fontSize: 13, paddingBottom: 12 }}>Este accordion inicia aberto com defaultOpen=true.</div>
      </Accordion>
      <Accordion title="Fechado por padrão">
        <div style={{ color: T.textSecondary, fontSize: 13, paddingBottom: 12 }}>Clique no título para expandir.</div>
      </Accordion>
      <Accordion title="Com badge" badge="3">
        <div style={{ color: T.textSecondary, fontSize: 13, paddingBottom: 12 }}>Accordion com badge numérico no título.</div>
      </Accordion>
    </div>
  ),
};
